export default function () {
    return m('a', {
        href: 'https://github.com/clarkwinkelmann/flarum-ext-composer-page',
        target: '_blank',
        rel: 'noopener',
    });
}
